import { render, staticRenderFns } from "./RedefinirSenha.vue?vue&type=template&id=3a244fe9&scoped=true&"
import script from "./RedefinirSenha.vue?vue&type=script&lang=js&"
export * from "./RedefinirSenha.vue?vue&type=script&lang=js&"
import style0 from "./RedefinirSenha.vue?vue&type=style&index=0&id=3a244fe9&prod&scoped=true&lang=css&"
import style1 from "./RedefinirSenha.vue?vue&type=style&index=1&id=3a244fe9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a244fe9",
  null
  
)

export default component.exports